module.exports = __webpack_public_path__ + "img/44.77add2c5.jpg";